import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { createAppRouter } from '@/app/router';
import { seedHistory } from '@/app/seedHistory';

import '@/index.css';
import { initializeReaderPreferences } from '@/lib/preferences/readerPreferences';

initializeReaderPreferences();
seedHistory();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={createAppRouter()} />
  </StrictMode>,
);
